import {NgModule, ModuleWithProviders} from '@angular/core';
import {NgbCollapse} from './collapse';

export {NgbCollapse} from './collapse';


export class NgbCollapseModule {
  static forRoot(): ModuleWithProviders { return {ngModule: NgbCollapseModule, providers: []}; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{declarations: [NgbCollapse], exports: [NgbCollapse]}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
